var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sop-filter" },
    [
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          ["SE"].includes(_vm.lob)
            ? _c(
                "div",
                {
                  staticClass: "more-filter-btn",
                  on: {
                    click: function($event) {
                      _vm.expandCondition = !_vm.expandCondition
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("CargoMsg.Cargo_MoreFilters")) + " "
                  ),
                  _c("i", {
                    class: _vm.expandCondition
                      ? "el-icon-arrow-up"
                      : "el-icon-arrow-down"
                  })
                ]
              )
            : _vm._t("filter"),
          _vm._t("other")
        ],
        2
      ),
      _vm.lob === "SE"
        ? _c("search-item", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.expandCondition,
                expression: "expandCondition"
              }
            ],
            key: "SESearchItem",
            ref: "SESearchItem",
            attrs: {
              "config-module": "100100",
              "show-simple": false,
              "expand-adv": true,
              reset: true,
              "custom-search-items": _vm.customSearchItems
            },
            on: {
              advSearchItemCallBack: _vm.toAdvancedQuery,
              resetFields: _vm.toResetFields,
              defaultSearchItemsChange: function(value) {
                _vm.defaultSearchItems = value
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "customType1",
                  fn: function(ref) {
                    var item = ref.item
                    var getValueFromChild = ref.getValueFromChild
                    return _c("cargo-advance-select", {
                      attrs: {
                        "select-type": _vm.TYPE_NAMES.basic_data_Company,
                        filterable: "",
                        "callback-params": {
                          refCode: item.itemName,
                          fieldType: item.fieldType
                        },
                        "default-value": item.itemValue,
                        "static-options": _vm.seCompanyOptions
                      },
                      on: {
                        parentCallBack: function(data) {
                          return getValueFromChild(data)
                        }
                      }
                    })
                  }
                },
                {
                  key: "customType2",
                  fn: function(ref) {
                    var item = ref.item
                    var getValueFromChild = ref.getValueFromChild
                    return _c("cargo-advance-select", {
                      attrs: {
                        "select-type": _vm.TYPE_NAMES.basic_data_Company,
                        "method-params": { consignee: true, active: true },
                        filterable: "",
                        "callback-params": {
                          refCode: item.itemName,
                          fieldType: item.fieldType
                        },
                        "default-value": item.itemValue,
                        "static-options": _vm.sePrivateConsigneeList
                      },
                      on: {
                        parentCallBack: function(data) {
                          return getValueFromChild(data)
                        }
                      }
                    })
                  }
                }
              ],
              null,
              false,
              1692892428
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }